import { IDictionary } from 'common/interfaces/main';

export const leadsInfo: Array<Array<IDictionary<string>>> = [
  [{ 'Legal Business Name: ': 'legalBusName' }],
  [{ 'DBA: ': 'dba' }],
  [
    { 'Physical Address: ': '' },
    { '': 'plAddress1', COMMA: 'plAddress2' },
    { 'Phone: ': 'plPhone', 'Extn: ': 'plExt' },
  ],
  [
    { '': '' },
    { '': 'plCity', COMMA: 'plState', ' ': 'plZipcode' },
    { 'Fax: ': 'plFax' },
  ],
  [
    { 'Contact: ': 'contactFName', '': 'contactLName' },
    { '': '' },
    { 'Phone: ': 'contactPhone', 'Extn: ': 'contactExt' },
  ],
  [{ 'Title: ': 'contactTitle' }, { '': '' }, { 'Email: ': 'contactEmail' }],
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/data/sales/leadsInfo.ts